import { render, staticRenderFns } from "./EditBusinessTableHis.vue?vue&type=template&id=84029cf2&scoped=true"
import script from "./EditBusinessTableHis.vue?vue&type=script&lang=js"
export * from "./EditBusinessTableHis.vue?vue&type=script&lang=js"
import style0 from "./EditBusinessTableHis.vue?vue&type=style&index=0&id=84029cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84029cf2",
  null
  
)

export default component.exports